import React from "react";

export default function ColorFrame3({ frameTextToggle, children }) {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width="300"
      height="300"
      viewBox="0 0 300 300"
    >
      <g transform={frameTextToggle}>
        <circle
          cx="137.615"
          cy="155.05"
          r="108.486"
          stroke="black"
          strokeWidth="23.4988"
        />
        <path
          d="M208.298 63.7683C203.314 72.7728 197.039 65.1199 187.597 59.8945C178.156 54.669 169.123 53.8497 174.107 44.8452C179.09 35.8407 190.784 32.7772 200.226 38.0027C209.667 43.2281 213.281 54.7638 208.298 63.7683Z"
          fill="black"
        />
        <path
          d="M216.336 22.6737C213.594 21.4988 207.328 21.1072 204.195 26.0027C200.161 32.3048 205.37 37.5563 193.62 42.6477"
          stroke="black"
          strokeWidth="7.83293"
        />
        <path
          d="M198.712 7.00813L209.669 18.0004L208.834 27.6966L217.028 24.6219L229.09 32.7931L224.079 19.3275L232.785 14.2127L220.982 11.0053L218.761 0.932346L213.642 8.48792L198.712 7.00813Z"
          fill="#FFC444"
        />
        <path
          d="M202.243 18.0004L210.878 22.1995L216.388 33.0945L222.129 22.2181L230.477 22.1995L225.833 14.2127L232.785 3.99989L217.698 8.59799L210.401 3.99989L210.107 13.9789L202.243 18.0004Z"
          fill="#FFC444"
        />
        <path
          d="M205.806 10.5712L212.117 16.9018L211.636 22.486L216.355 20.7152L223.302 25.4212L220.415 17.6661L225.429 14.7204L218.632 12.8732L217.353 7.07201L214.405 11.4234L205.806 10.5712Z"
          fill="#F36F56"
        />
        <path
          d="M207.84 16.9018L212.813 19.3202L215.986 25.5948L219.293 19.3309L224.1 19.3202L221.426 14.7204L225.429 8.83867L216.74 11.4868L212.538 8.83866L212.369 14.5858L207.84 16.9018Z"
          fill="#F36F56"
        />
        {children}
      </g>
    </svg>
  );
}
